import { Component, Input } from '@angular/core';

@Component({
    selector: 'cv-wallboard-view-error',
    templateUrl: './wallboard-view-error.component.html',
    styleUrls: ['./wallboard-view-error.component.scss']
})
export class WallboardViewErrorComponent {
    @Input() errorMessage: string = 'This wallboard is no longer available';
}
